import { Box, Grid, InputLabel } from '@mui/material';
import { INTEGERS_UNIT } from '../../../utils/regex';
import AutocompleteComponent from '../../../components/Autocomplete/Autocomplete';
import Button from '../../../components/Button/Button';
import Input from '../../../components/Input/Input';
import DatePickerComponent from '../../../components/DatePicker';

function Filters({
    handleChangeExtraFilters,
    extraFilters,
    handleClearFilters,
    handleSearch,
    inputTypeDocOptions,
    loadingEnabledDocs,
    fetchingEnabledDocs
}: any) {
    return (
        <Box
            sx={{
                minHeight: '156px',
                height: 'auto',
                mb: '12px',
                mt: 2,
                '& span': {
                    color: '#656565'
                }
            }}
        >
            <span>Filtrar por:</span>
            <Grid
                container
                spacing={2}
                sx={{
                    '& .MuiGrid-item': {
                        paddingTop: '8px'
                    }
                }}
            >
                <Grid item xs={6} sm={2}>
                    <InputLabel title="Fecha desde" />
                    <DatePickerComponent
                        value={extraFilters?.fechaDesde || ''}
                        name="fechaDesde"
                        label="Fecha desde"
                        setValue={(value: any) =>
                            handleChangeExtraFilters({
                                target: {
                                    name: 'fechaDesde',
                                    value: value
                                }
                            })
                        }
                        width="100%"
                    />
                </Grid>
                <Grid item xs={6} sm={2}>
                    <InputLabel title="Fecha hasta" />
                    <DatePickerComponent
                        value={extraFilters?.fechaHasta || ''}
                        name="fechaHasta"
                        label="Fecha hasta"
                        setValue={(value: any) =>
                            handleChangeExtraFilters({
                                target: {
                                    name: 'fechaHasta',
                                    value: value
                                }
                            })
                        }
                        width="100%"
                    />
                </Grid>
                <Grid item xs={6} sm={2}>
                    <Input
                        name="cuilPropietario"
                        onChange={(e: any) => {
                            let value = e.target.value;
                            if ((INTEGERS_UNIT.test(value) || value === '') && value?.length < 20) {
                                handleChangeExtraFilters({
                                    target: { name: 'cuilPropietario', value: value }
                                });
                            }
                        }}
                        disabled={!!extraFilters?.cuitPropietario}
                        placeholder="Cuil Propietario"
                        value={extraFilters?.cuilPropietario || ''}
                        fullWidth
                    />
                </Grid>
                <Grid item xs={6} sm={2}>
                    <Input
                        name="cuitPropietario"
                        onChange={(e: any) => {
                            let value = e.target.value;
                            if ((INTEGERS_UNIT.test(value) || value === '') && value?.length < 20) {
                                handleChangeExtraFilters({
                                    target: { name: 'cuitPropietario', value: value }
                                });
                            }
                        }}
                        disabled={!!extraFilters?.cuilPropietario}
                        placeholder="Cuit Propietario"
                        value={extraFilters?.cuitPropietario || ''}
                        fullWidth
                    />
                </Grid>
                <Grid item xs={6} sm={2}>
                    <Input
                        name="referenciaAdicionalPropietario"
                        onChange={handleChangeExtraFilters}
                        placeholder="Referencia adicional"
                        value={extraFilters?.referenciaAdicionalPropietario || ''}
                        fullWidth
                    />
                </Grid>
                <Grid item xs={6} sm={2}>
                    <AutocompleteComponent
                        value={(inputTypeDocOptions && (extraFilters?.idTipoDocumento || -1)) || ''}
                        onChange={(e: any) =>
                            handleChangeExtraFilters({
                                target: {
                                    name: 'idTipoDocumento',
                                    value: e?.id
                                }
                            })
                        }
                        loading={loadingEnabledDocs || fetchingEnabledDocs}
                        options={inputTypeDocOptions}
                        label="Tipo de documento"
                    />
                </Grid>
                <Grid item xs={12} sx={{ display: 'flex', justifyContent: 'end', gap: '15px' }}>
                    <Button onClick={handleClearFilters} type="text">
                        Limpiar filtros
                    </Button>
                    <Button onClick={handleSearch}>Buscar</Button>
                </Grid>
            </Grid>
        </Box>
    );
}

export default Filters;
